import { render } from "./EditTopicBox.vue?vue&type=template&id=3c78a5bc&scoped=true&ts=true"
import script from "./EditTopicBox.vue?vue&type=script&lang=ts"
export * from "./EditTopicBox.vue?vue&type=script&lang=ts"

import "./EditTopicBox.vue?vue&type=style&index=0&id=3c78a5bc&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c78a5bc"]])

export default __exports__